<div class="sidebar__content">
  <div class="sidebar__desc">
    Please review the aerotriangulation results and proceed to the production or retry AT step with
    different settings
  </div>
</div>
<app-tab-actions
  [backAction]="onRetry"
  backActionName="Retry"
  [nextAction]="onContinue"
  [nextActionPermission]="canAccept && !isFailed"
  [backActionPermission]="canRetry"
  [log]="log"
></app-tab-actions>
